module.exports = __webpack_public_path__ + "static/media/logo-completa-branca.efd7eb2b.png";